export default __webpack_public_path__ + "static/media/Accreditation-2.5df78327.png";